import { useState } from 'react';
import { Marker } from '@vis.gl/react-google-maps';

export const StoreLocatorMarker = ({ store, setActiveStore, activeStore }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <Marker
        onClick={() => {
          if (setActiveStore) {
            const storeLocationElement = document.querySelector(`#store-${store.handle}`)?.closest('.store-location');
            setActiveStore(store);

            if (storeLocationElement) {
              const scrollableArea = document.querySelector('.store-locator__stores-list');
              const scrollableAreaTop = scrollableArea.getBoundingClientRect().top;
              const storeLocationElementTop = storeLocationElement.getBoundingClientRect().top;
              const scrollTarget = storeLocationElementTop - scrollableAreaTop + scrollableArea.scrollTop;

              document.querySelector('.store-locator__stores-list').scrollTo({
                top: scrollTarget,
                behavior: 'smooth'
              });
            }

            storeLocationElement.querySelector('.store-location__name--clickable').focus({
              preventScroll: true
            });
          }
        }}
        position={{lat: parseFloat(store.latitude), lng: parseFloat(store.longitude)}}
        icon={{
          url: (activeStore?.id == store.id || isHovered) ? 'https://cdn.shopify.com/s/files/1/0671/0093/4313/files/map-pin-fill_f5d8154e-d125-4ecd-9683-204c8aedaef4.svg?v=1744835712' : 'https://cdn.shopify.com/s/files/1/0671/0093/4313/files/map-pin-fill.svg?v=1744835671',
          scaledSize: {width: 32, height: 32}
        }}
        onMouseOver={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
      />
    </>
  )
}
